<div class="gold-upgrade-left">
  <app-icon [icon]="'aha-gold-upgrade-now'"></app-icon>
</div>
